(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["addresses"]) return;
  try {
    
  window.melanieLib.addresses.then(function (addresses) {
    addresses.initialize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  const container = document.querySelector('.cart-section');
  window.melanieLib.cart.then(function (cart) {
    cart.initialize(container);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login"]) return;
  try {
    
  window.melanieLib.login.then(function (login) {
    login.initialize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-bar"]) return;
  try {
    
  window.melanieLib.application.then(function (application) {
    application.default.navBar.initialize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-dynamic-sections"]) return;
  try {
    
  window.melanieLib.product.then(function (product) {
    product.default.dynamicSections.initialize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-overview"]) return;
  try {
    
  window.melanieLib.product.then(function (product) {
    product.default.productOverview.initialize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["register"]) return;
  try {
    
  window.melanieLib.register.then(function (register) {
    register.initialize();
  });

  } catch(e) { console.error(e); }
})();
})();
